import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"

const registerEnrollmentNewModule: ModuleRegisterFn = (_context: ModuleRegisterContext) => {
  console.log("enrollment new module registered!")
}

export default registerEnrollmentNewModule
